export function normalizeAssignedGroupIds(userData) {
  const raw =
    userData?.assignedGroupIds ||
    userData?.shiftsAssignedGroupIds ||
    userData?.locationGroupIds ||
    [];

  if (!Array.isArray(raw)) return [];

  return [...new Set(raw.map((id) => String(id || '').trim()).filter(Boolean))];
}

export function hasLocationRestrictions(userData) {
  return normalizeAssignedGroupIds(userData).length > 0;
}

export function canAccessGroup(userData, groupId) {
  if (!groupId) return !hasLocationRestrictions(userData);
  if (!hasLocationRestrictions(userData)) return true;
  return normalizeAssignedGroupIds(userData).includes(String(groupId));
}

export function filterGroupsByAccess(groups = [], userData) {
  if (!hasLocationRestrictions(userData)) return groups;
  return groups.filter((group) => canAccessGroup(userData, group.id));
}

export function filterShiftsByAccess(shifts = [], userData) {
  if (!hasLocationRestrictions(userData)) return shifts;
  return shifts.filter((shift) => canAccessGroup(userData, shift.groupId));
}

export function filterStaffByAccess(staff = [], userData, currentUserId = null) {
  if (!hasLocationRestrictions(userData)) return staff;

  const allowed = normalizeAssignedGroupIds(userData);

  return staff.filter((member) => {
    if (currentUserId && member.id === currentUserId) return true;
    const memberGroups = normalizeAssignedGroupIds(member);
    return memberGroups.some((groupId) => allowed.includes(groupId));
  });
}

export function getAccessibleGroupNames(userData, groups = []) {
  const allowed = normalizeAssignedGroupIds(userData);
  if (!allowed.length) return [];
  return groups.filter((group) => allowed.includes(group.id)).map((group) => group.name).filter(Boolean);
}
